import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});


const ModalInvestingTeam = ({ closeModal, openModal, feasibility, listarEquipoInvestigacion, data_profesional, membersTeam }) => {
    //Datos Basicos
    const [allProfesionals, setAllProfesionals] = React.useState([]);
    const [roles, setRoles] = React.useState([]);
    const [profesional, setProfesional] = React.useState(null);
    const [rol, setRol] = React.useState(null);
    const [dateStart, setDateStart] = React.useState(null);
    const [dateFinal, setDateFinal] = React.useState(null);
    const [institutionTime, setInstitutionTime] = React.useState(null);
    const [projectTime, setProjectTime] = React.useState(null);

    //Loader
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const onOk = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            closeModal();
        }
    }

    const addMember = async () => {
        //Validaciones
        if (profesional == null || profesional == "") {
            alertModal(false, "El Profesional es Obligatorio");
            return;
        }
        if (rol == null || rol == "") {
            alertModal(false, "El Rol es Obligatorio");
            return;
        }
        if (dateStart == null || dateStart == "") {
            alertModal(false, "La fecha inicial es Obligatoria");
            return;
        }
        if (institutionTime == null || institutionTime == "") {
            alertModal(false, "El Tiempo de Insitución es Obligatorio");
            return;
        }
        if (projectTime == null || projectTime == "") {
            alertModal(false, "El Tiempo Proyecto es Obligatorio");
            return;
        }

        let dataSend = {
            id_profesional: profesional,
            id_rol: rol,
            fecha_inicio: moment(dateStart).format('YYYY/MM/DD'),
            fecha_final: null,
            id_estudio: feasibility.id_estudio,
            tiempo_institucion: institutionTime,
            tiempo_proyecto: projectTime
        };

        if (membersTeam.length > 0) {
            let existe = membersTeam.some(member => member.id_profesional == profesional);
            if (existe == true) {
                alertModal(false, "El Profesional ya existe en el Equipo Investigador de este estudio");
                return;
            }
        }

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}equipoinves/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => response.json()).then(data => {
            listarEquipoInvestigacion();
            closeModal();
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el sistema");
        });
    }

    const updateMember = async () => {
        //Validaciones
        if (profesional == null || profesional == "") {
            alertModal(false, "El Profesional es Obligatorio");
            return;
        }
        if (rol == null || rol == "") {
            alertModal(false, "El Rol es Obligatorio");
            return;
        }
        if (dateStart == null || dateStart == "") {
            alertModal(false, "La fecha inicial es Obligatoria");
            return;
        }
        if (institutionTime == null || institutionTime == "") {
            alertModal(false, "El Tiempo de Insitución es Obligatorio");
            return;
        }
        if (projectTime == null || projectTime == "") {
            alertModal(false, "El Tiempo Proyecto es Obligatorio");
            return;
        }

        let dataSend = {
            id_equipo_inv: data_profesional.id_equipo_inv,
            id_rol: rol,
            fecha_inicio: moment(dateStart).format('YYYY/MM/DD'),
            fecha_final: moment(dateFinal).format('YYYY/MM/DD'),
            tiempo_institucion: institutionTime,
            tiempo_proyecto: projectTime
        };

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}equipoinves/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => response.json()).then(data => {
            listarEquipoInvestigacion();
            closeModal();
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el sistema");
        });
    }

    const listProfessional = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}profesional/listar`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setAllProfesionals(data);
        }).catch(err => {
            setAllProfesionals([]);
        });
    }

    const listTipo = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}equipoinves/listar-roles`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setRoles(data);
        }).catch(err => {
            setRoles([]);
        });
    }

    React.useEffect(() => {
        listProfessional();
        listTipo();

        if (data_profesional != null && data_profesional != undefined) {
            setProfesional(data_profesional.id_profesional);
            setRol(data_profesional.id_rol);
            setDateStart(data_profesional.fecha_inicio != null ? new Date(data_profesional.fecha_inicio) : null);
            setDateFinal(data_profesional.fecha_final != null ? new Date(data_profesional.fecha_final) : null);
            setInstitutionTime(data_profesional.tiempo_institucion);
            setProjectTime(data_profesional.tiempo_proyecto);
        }

    }, []);

    return (
        <div>
            <Modal
                open={openModal}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {
                                data_profesional != null && data_profesional != undefined ?
                                    <h5 className="bold-text">Actualizar Miembro</h5>
                                    :
                                    <h5 className="bold-text">Agregar Miembro</h5>
                            }
                        </div>

                        <Row>
                            <Col md={6}>
                                <TextField
                                    id="select-profesional"
                                    label="Profesional"
                                    select
                                    disabled={data_profesional !== undefined && data_profesional !== null ? true : false}
                                    value={profesional}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setProfesional(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    {allProfesionals.map((prof) => {
                                        return <MenuItem key={prof.id_profesional} value={prof.id_profesional}>
                                            {
                                                prof.apellido2 != null ?
                                                    prof.nombres + " " + prof.apellido1 + " " + prof.apellido2
                                                    :
                                                    prof.nombres + " " + prof.apellido1
                                            }
                                            {prof.label}
                                        </MenuItem>
                                    })}
                                </TextField>
                            </Col>
                            <Col md={6}>
                                <TextField
                                    id="select-rol"
                                    label="Rol en el Estudio"
                                    select
                                    value={rol}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setRol(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    {roles.map((rol_estudio) => {
                                        return <MenuItem key={rol_estudio.id_rol} value={rol_estudio.id_rol}>
                                            {rol_estudio.rol}
                                        </MenuItem>
                                    })}
                                </TextField>
                            </Col>
                            <Col md={6}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <KeyboardDatePicker
                                            variant="inline"
                                            value={dateStart}
                                            onChange={(date) => {
                                                setDateStart(date);
                                            }}
                                            //disabled={data_profesional !== undefined && data_profesional !== null ? true : false}
                                            label="Fecha de Inicio"
                                            format="yyyy/MM/DD"
                                            animateYearScrolling
                                            className='medical-material-form__field material-form__label'
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={6}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <KeyboardDatePicker
                                            variant="inline"
                                            value={dateFinal}
                                            onChange={(date) => {
                                                setDateFinal(date);
                                            }}
                                            label="Fecha Final"
                                            format="yyyy/MM/DD"
                                            animateYearScrolling
                                            className='medical-material-form__field material-form__label'
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                            disabled={data_profesional != null && data_profesional != undefined ? false : true}
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={6}>
                                <TextField
                                    id="txtTimeInstitution"
                                    label="Tiempo de Institución (horas/mes)"
                                    value={institutionTime}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setInstitutionTime(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    id="txtTimeProject"
                                    label="Tiempo Proyecto (horas/mes)"
                                    value={projectTime}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setProjectTime(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>

                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            data_profesional == null ? <Button
                                disabled={false}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    addMember();
                                }}
                            >
                                Crear
                            </Button>
                                :
                                <Button
                                    disabled={false}
                                    style={{ marginTop: 10, marginRight: 10 }}
                                    variant="contained"
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => {
                                        updateMember();
                                    }}
                                >
                                    Actualizar
                                </Button>
                        }





                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOk(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalInvestingTeam;
